module.exports = __webpack_public_path__ + "img/d201109-1.e0a839d3.jpg";